import React, { useContext } from 'react'
import './Navbar.css';
import logo from '../../assets/logo.png'
import myContext from '../../Context/Context';
import { Link } from 'react-router-dom';
function Navbar() {
    const {currency,setCurrency} = useContext(myContext);
    const handleChange=(event)=>{
        switch(event.target.value){
            case 'usd':{
                setCurrency({name:'usd',symbol:"$"})
                break;
            }
            case 'inr':{
                setCurrency({name:'inr',symbol:"₹"})
                break;
            }
            case 'eur':{
                setCurrency({name:'eur',symbol:"€"})
                break;
            }
            default:{
                setCurrency({name:'usd',symbol:"$"})
                break
            }
                
        }
    }
  return (
    <nav>
        <div className='container-xl'>
            <div className='navigation'>
            <Link to="/">
                <img className='logo' src={logo} alt='logo'/>
            </Link>
                <ul className='navlink d-none d-md-flex'>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/">Features</Link></li>
                    <li><Link to="/">Pricing</Link></li>
                    <li><Link to="/">Blog</Link></li>
                </ul>
                <div className='nav_btns'>
                    <select value={currency.name} onChange={handleChange}>
                        <option value="usd">USD</option>
                        <option value="inr">INR</option>
                        <option value='eur'>EUR</option>
                    </select>
                </div>
            </div>
        </div>
    </nav>
  )
}

export default Navbar